export default __webpack_public_path__ + "6d38886d49f44322546e5b413aa627a8.svg";